var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (displayAuthors, item, showCoverImage) {pug_mixins["teaser"] = pug_interp = function(item){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"teaser__item\"\u003E";
pug_mixins["meta"](item);
pug_mixins["heading"](item);
if ((item.contribs && displayAuthors)) {
pug_html = pug_html + (null == (pug_interp = item.contribs) ? "" : pug_interp);
}
if ((item.abstract)) {
pug_html = pug_html + "\u003Cdiv class=\"creative-work__abstract\"\u003E" + (null == (pug_interp = item.abstract) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["heading"] = pug_interp = function(item){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if ((item.title)) {
if ((item.best)) {
pug_html = pug_html + "\u003Ca" + (" class=\"teaser__item__title\""+pug.attr("href", item.best, true, true)+pug.attr("title", item.title, false, true)) + "\u003E" + (null == (pug_interp = item.title) ? "" : pug_interp) + "\u003C\u002Fa\u003E";
}
else
if ((item.url)) {
pug_html = pug_html + "\u003Ca" + (" class=\"teaser__item__title\""+pug.attr("href", item.url, true, true)+pug.attr("title", item.title, false, true)) + "\u003E" + (null == (pug_interp = item.title) ? "" : pug_interp) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"teaser__item__title\"\u003E" + (null == (pug_interp = item.title) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
}
};
pug_mixins["meta"] = pug_interp = function(item){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"teaser__item__info\"\u003E";
var accessCaptions ={'free':"",'full':"",'open':"",'no':"",'part':""}
if (item.accessIcon === "full") {
pug_html = pug_html + "\u003Cspan class=\"meta__access\"\u003E\u003Ci class=\"icon-lock_open\" aria-hidden=\"true\"\u003E\u003C\u002Fi\u003E";
if ((accessCaptions.full)) {
pug_html = pug_html + "\u003Cspan class=\"citation__access__type full-access\"\u003E" + (null == (pug_interp = accessCaptions.full) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fspan\u003E";
}
else
if (item.accessIcon === "free") {
pug_html = pug_html + "\u003Cspan class=\"meta__access\"\u003E\u003Ci class=\"icon-lock_open\" aria-hidden=\"true\"\u003E\u003C\u002Fi\u003E";
if ((accessCaptions.free)) {
pug_html = pug_html + "\u003Cspan class=\"citation__access__type free-access\"\u003E" + (null == (pug_interp = accessCaptions.free) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fspan\u003E";
}
else
if (((item.accessIcon === "open") || (item.accessIcon === "oa"))) {
pug_html = pug_html + "\u003Cspan class=\"meta__access\"\u003E\u003Ci class=\"icon-open_access\" aria-hidden=\"true\"\u003E\u003C\u002Fi\u003E";
if ((accessCaptions.open)) {
pug_html = pug_html + "\u003Cspan class=\"citation__access__type open-access\"\u003E" + (null == (pug_interp = accessCaptions.open) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fspan\u003E";
}
else
if (item.accessIcon === "no") {
pug_html = pug_html + "\u003Cspan class=\"meta__access\"\u003E\u003Ci class=\"icon-lock\" aria-hidden=\"true\"\u003E\u003C\u002Fi\u003E";
if ((accessCaptions.no)) {
pug_html = pug_html + "\u003Cspan class=\"citation__access__type no-access\"\u003E" + (null == (pug_interp = accessCaptions.no) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fspan\u003E";
}
else
if (item.accessIcon === "part") {
pug_html = pug_html + "\u003Cspan class=\"meta__access\"\u003E\u003Ci class=\"icon-drag_handle limited-access\" aria-hidden=\"true\"\u003E\u003C\u002Fi\u003E";
if ((accessCaptions.part)) {
pug_html = pug_html + "\u003Cspan class=\"citation__access__type part-access\"\u003E" + (null == (pug_interp = accessCaptions.part) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fspan\u003E";
}
if ((item)) {
if ((item.group && item.group.coverDate)) {
pug_html = pug_html + "\u003Cspan\u003E" + (null == (pug_interp = item.group.coverDate) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
}
else
if ((item.epubDate)) {
pug_html = pug_html + "\u003Cspan\u003E" + (null == (pug_interp = item.epubDate) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
}
else
if ((item.date)) {
pug_html = pug_html + "\u003Cspan\u003E" + (null == (pug_interp = item.date) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
}
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_html = pug_html + "\u003Cli class=\"multi-search__item multi-search__with-image mb-4\"\u003E";
if ((showCoverImage)) {
pug_html = pug_html + "\u003Cdiv class=\"multi-search--image\"\u003E\u003Ca" + (pug.attr("href", item.best, true, true)) + "\u003E";
if (item.keyImage) {
pug_html = pug_html + "\u003Cimg" + (pug.attr("src", item.keyImage.src, true, true)+pug.attr("alt", item.group && item.group.coverImage ? item.group.coverImage.caption : null, true, true)) + "\u003E";
}
else
if (item.group && item.group.serial && item.group.serial.coverImage) {
pug_html = pug_html + "\u003Cimg" + (pug.attr("src", item.group.serial.coverImage.src, true, true)+pug.attr("alt", item.group && item.group.coverImage ? item.group.coverImage.caption : null, true, true)) + "\u003E";
}
else
if (item.mediaCode && item.mediaCode[0] && item.mediaCode[0].uri && item.mediaCode[0].uri === 'tvnews') {
pug_html = pug_html + "\u003Cimg" + (" src=\"\u002Fpb-assets\u002Fimages\u002Fseries-logos\u002Fproduct-tvnews.png\""+pug.attr("alt", item.group && item.group.coverImage ? item.group.coverImage.caption : null, true, true)) + "\u003E";
}
else
if (item.mediaCode && item.mediaCode[0] && item.mediaCode[0].uri && item.mediaCode[0].uri === 'edutv') {
pug_html = pug_html + "\u003Cimg" + (" src=\"\u002Fpb-assets\u002Fimages\u002Fseries-logos\u002Fproduct-edutv.png\""+pug.attr("alt", item.group && item.group.coverImage ? item.group.coverImage.caption : null, true, true)) + "\u003E";
}
pug_html = pug_html + "\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
}
if ((item)) {
pug_mixins["teaser"](item);
}
pug_html = pug_html + "\u003C\u002Fli\u003E";}.call(this,"displayAuthors" in locals_for_with?locals_for_with.displayAuthors:typeof displayAuthors!=="undefined"?displayAuthors:undefined,"item" in locals_for_with?locals_for_with.item:typeof item!=="undefined"?item:undefined,"showCoverImage" in locals_for_with?locals_for_with.showCoverImage:typeof showCoverImage!=="undefined"?showCoverImage:undefined));;return pug_html;};
module.exports = template;